import Advertiser from './index.vue'

export default [{
    path: '/advertiser',
    name: 'advertiser',
    component: Advertiser,
}]